var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.missedAlotWarning)?_c('div',[_c('v-alert',{attrs:{"color":"deep-orange","icon":"mdi-alert","type":"warning","dismissible":true}},[_vm._v(_vm._s(_vm.missedAlotWarning))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }